const _import = require('./_import')
const layout = _import('Layout/Layout');
export const Routers = [{
    path: '/',
    component: layout,
    redirect: "/Home",
    children: [{
        path: '/Home',
        component: _import('Layout/Home'),
        name: 'Home',
        single: true,
        meta: {
            title: "首页",
            icon: "home"
        }
    }]
}, {
    path: '/art',
    component: layout,
    name: "艺术节管理",
    meta: {
        title: "艺术节管理",
        icon: "dashboard"
    },
    children: [{
        path: 'art',
        name: 'art',
        component: _import("Art/atFestival"),
        meta: {
            title: "艺术节管理",
            icon: "info"
        },
    }, {
        path: 'atgroup',
        name: 'atgroup',
        component: _import("Art/atGroup"),
        meta: {
            title: "大赛组别管理",
            icon: "info"
        },
    }, {
        path: 'atsignup',
        name: 'atsignup',
        component: _import("Art/atSignUp"),
        meta: {
            title: "大赛报名管理",
            icon: "info"
        },
    }, {
        path: 'atroom',
        name: 'atroom',
        component: _import("Art/atRoom"),
        meta: {
            title: "大赛排期管理",
            icon: "info"
        },
    }, {
        path: 'atreview',
        name: 'atreview',
        component: _import("Art/atReview"),
        meta: {
            title: "大赛评审管理",
            icon: "info"
        },
    }, {
        path: 'master',
        name: 'master',
        component: _import("Art/atMaster"),
        meta: {
            title: "大师管理",
            icon: "info"
        },
    }, {
        path: 'player',
        name: 'player',
        component: _import("Art/atPlayer"),
        meta: {
            title: "人员管理",
            icon: "info"
        },
    }, {
        path: 'course_mgr',
        name: 'course_mgr',
        component: _import("Art/atCourse"),
        meta: {
            title: "课程管理",
            icon: "info"
        },
    }, {
        path: 'course',
        name: 'course',
        component: _import("Art/atCourseTicket"),
        meta: {
            title: "课程报名管理",
            icon: "info"
        },
    }
    ]
},{
    path: '/buss',
    component: layout,
    name: "考务管理",
    meta: {
        title: "考务管理",
        icon: "dashboard"
    },
    children: [{
        path: 'record',
        name: 'record',
        component: _import("Goods/record"),
        meta: {
            title: "历史报名",
            icon: "info"
        },
    },
        {
            path: 'categoryPrice',
            name: 'categoryPrice',
            component: _import("Goods/treePrice"),
            meta: {
                title: "科目价格",
                icon: "info"
            },
        },
        {
            path: 'csNee',
            name: 'csNee',
            component: _import("Examination/examineeManager"),
            meta: {
                title: "考生管理",
                icon: "info"
            },
        },
        {
            path: 'signup',
            name: 'signup',
            component: _import("Goods/signUp"),
            meta: {
                title: "报名管理",
                icon: "info"
            },
        },
        // 2022年11月01日09:31:17
        {
            path: 'examSite',
            name: 'examSite',
            component: _import("Examination/examination"),
            meta: {
                title: "考点管理",
                icon: "info"
            },
        },
        {
            path: 'examRoom',
            name: 'examRoom',
            component: _import("Examination/examRoom"),
            meta: {
                title: "考场管理",
                icon: "info"
            },
        },
        {
            path: 'roomItem',
            name: 'roomItem',
            component: _import("Examination/roomItem"),
            meta: {
                title: "考场排期",
                icon: "info"
            },
        },
        {
            path: 'downLoad',
            name: 'downLoad',
            component: _import("Examination/downLoad"),
            meta: {
                title: "下载管理",
                icon: "info"
            },
        },
        {
            path: 'csIdFile',
            name: 'csIdFile',
            component: _import("Goods/examineeIdFile"),
            meta: {
                title: "证照管理",
                icon: "info"
            },
        }
        // end
    ]
}, {
    path: '/rvj',
    component: layout,
    name: "考评管理",
    meta: {
        title: "考评管理",
        icon: "dashboard"
    },
    children: [{
        path: 'judger',
        name: 'judger',
        component: _import("Rvj/judger"),
        meta: {
            title: "考官管理",
            icon: "info"
        },
    }, {
        path: 'judgerItem',
        name: 'judgerItem',
        component: _import("Rvj/judgerItem"),
        meta: {
            title: "考评列表",
            icon: "info"
        },
    }, {
        path: 'judgerlog',
        name: 'judgerlog',
        component: _import("Rvj/judgerLog"),
        meta: {
            title: "考评日志",
            icon: "info"
        },
    }
    ]
},
    {
        path: '/exp',
        component: layout,
        name: "线上考试",
        meta: {
            title: "线上考试",
            icon: "dashboard"
        },
        children: [
            {
                path: 'minee',
                name: 'minee',
                component: _import("Goods/pianoexaminee"),
                meta: {
                    title: "考生列表",
                    icon: "info"
                },
            },
            {
                path: 'vie',
                name: 'vie',
                component: _import("Goods/pianovideo"),
                meta: {
                    title: "考试视频",
                    icon: "info"
                },
            }
        ]
    },
    {
        path: '/expe',
        component: layout,
        name: "考试管理",
        meta: {
            title: "考试管理",
            icon: "dashboard"
        },
        children: [{
            path: 'major',
            name: 'major',
            component: _import("Goods/exammajor"),
            meta: {
                title: "专业管理",
                icon: "info"
            },
        },
            {
                path: 'gra',
                name: 'gra',
                component: _import("Goods/examgrade"),
                meta: {
                    title: "等级管理",
                    icon: "info"
                },
            }, {
                path: 'exam',
                name: 'exam',
                component: _import("Goods/pianoexam"),
                meta: {
                    title: "考试列表",
                    icon: "info"
                },
            }
        ]
    },

    {
        path: '/Login',
        hidden: true,
        component: _import('Login/Index'),
        name: 'Login',
        meta: {
            title: "登录"
        }
    },
    {
        path: '/user',
        component: layout,
        name: "用户管理",
        meta: {
            title: "用户管理",
            icon: "dashboard"
        },
        children: [{
            path: 'UserList',
            name: 'UserList',
            component: _import("User/UserList/Index"),
            meta: {
                title: "用户列表",
                icon: "info"
            }
        }, {
            path: 'MenuList',
            name: 'MenuList',
            component: _import("Authority/Menu/Index"),
            meta: {
                title: "菜单列表",
                icon: "info"
            }
        }, {
            path: 'RoleList',
            name: 'RoleList',
            component: _import("Authority/Role/Index"),
            meta: {
                title: "角色列表",
                icon: "info"
            }
        }
        ]
    },
    {
        path: '/sys',
        component: layout,
        name: "系统管理",
        meta: {
            title: "系统管理",
            icon: "dashboard"
        },
        children: [{
            path: 'TableList',
            name: 'TableList',
            component: _import("Syslog/TableList/Index"),
            meta: {
                title: "表结构",
                icon: "info"
            },

        },

            {
                path: 'ErrorLog',
                name: 'ErrorLog',
                component: _import("Syslog/ErrorLog/Index"),
                meta: {
                    title: "错误日志",
                    icon: "info"
                },
                auth: "ErrorLog"
            },
            {
                path: 'Job',
                name: 'Job',
                component: _import("System/Job/Index"),
                meta: {
                    title: "定时任务",
                    icon: "info"
                },
                auth: "Job",
            },
            {
                path: 'JobLog',
                name: 'JobLog',
                component: _import("System/Job/JobLog"),
                meta: {
                    title: "任务日志",
                    icon: "info"
                },
                auth: "JobLog",
            },
            {
                path: 'Config',
                name: 'Config',
                component: _import("System/Config/Index"),
                meta: {
                    title: "配置管理",
                    icon: "info"
                },
                auth: "Config",
            },
            {
                path: 'signUpImportLog',
                name: 'signUpImportLog',
                component: _import("System/Log/SignUpImportLog"),
                meta: {
                    title: "考级导入日志",
                    icon: "info"
                },
                auth: "signUpImportLog",
            },
            {
                path: 'idFileZipImportLog',
                name: 'idFileZipImportLog',
                component: _import("System/Log/IdFileZipImportLog"),
                meta: {
                    title: "证照导入日志",
                    icon: "info"
                },
                auth: "idFileZipImportLog",
            }
        ]
    },//报表管理
    {
        path: '/report',
        component: layout,
        name: "报表管理",
        meta: {
            title: "报表管理",
            icon: "dashboard"
        },
        children: [{
                path: 'coursesRanking',
                name: 'coursesRanking',
                component: _import("Report/coursesRanking"),
                meta: {
                    title: "艺术节课程排行榜",
                    icon: "info"
                }
            },
            {
                path: 'coursesSessionRanking',
                name: 'coursesSessionRanking',
                component: _import("Report/coursesSessionRanking"),
                meta: {
                    title: "艺术节课程场次排行榜",
                    icon: "info"
                }
            },
            {
                path: 'matchsRanking',
                name: 'matchsRanking',
                component: _import("Report/matchsRanking"),
                meta: {
                    title: "艺术节比赛分组排行榜",
                    icon: "info"
                }
            }
        ]
    }
]
